import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const columnStyle = {
  color: "#828282",
  align: "right",
  fontWeight: 500,
  minWidth: 170,
  maxWidth: 170,
  fontSize: "1.125rem",
  fontFamily: "Montserrat",
};

const textStyle = {
  fontWeight: 500,
  fontSize: "1.125rem",
  fontFamily: "Montserrat",
};

const captionStyle = {
  background: "#004990",
  color: "#FFF",
  borderRadius: "10px",
  fontFamily: "Montserrat",
};

const columns = [
  { id: "name", label: "Negocios" },
  { id: "order", label: "# Ordenes" },
  {
    id: "sending",
    label: "Envíos Tienda",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "sendingcl",
    label: "Envíos Cliente",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "propines",
    label: "Propinas",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "commission",
    label: "Comisión Niku(50%)",
    format: (value) => value.toLocaleString("en-US"),
  },
  { id: "total", label: "Ganancias", format: (value) => value.toFixed(2) },
];

export default function StickyHeadTable({ data }) {
  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: 706 }}>
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={{ fontFamily: "Montserrat" }}
        >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} sx={columnStyle}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  <TableCell key={"name"} align={"left"} sx={textStyle}>
                    {row.shop_name}
                  </TableCell>
                  <TableCell key={"order"} align={"left"} sx={textStyle}>
                    {row.orders.length}
                  </TableCell>
                  <TableCell key={"sending"} align={"left"} sx={textStyle}>
                    ${row.comSendShops}
                  </TableCell>
                  <TableCell key={"sendingcl"} align={"left"} sx={textStyle}>
                    ${row.comSendClients}
                  </TableCell>
                  <TableCell key={"propines"} align={"left"} sx={textStyle}>
                    ${row.amountPropine}
                  </TableCell>
                  <TableCell key={"commission"} align={"left"} sx={textStyle}>
                    ${row.comisionNks}
                  </TableCell>
                  <TableCell key={"total"} align={"left"} sx={textStyle}>
                    ${row.total.toFixed(2)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <caption style={captionStyle}>dd/mm/aaaa</caption>
        </Table>
      </TableContainer>
    </Paper>
  );
}
